module.exports = __webpack_public_path__ + "3c4eab75f1d9924896de34684487368b.pdf";